export const GET_STRIPE_CUSTOMER_DETAILS_SUCCESS = 'GET_STRIPE_CUSTOMER_DETAILS_SUCCESS';
export const GET_STRIPE_CUSTOMER_DETAILS_ERROR = 'GET_STRIPE_CUSTOMER_DETAILS_ERROR';
export const CHECK_DISCOUNT_CODE_IS_VALID_SUCCESS = 'CHECK_DISCOUNT_CODE_IS_VALID_SUCCESS';

export const GET_SIGNUP_OPTIONS_SUCCESS = 'GET_SIGNUP_OPTIONS_SUCCESS';

export const ADD_NOTIFICATION_SUCCESS = 'ADD_NOTIFICATION_SUCCESS';



// WEBPACK FOOTER //
// ./library/app/actions/actionTypes.js